module.exports = __webpack_public_path__ + "560de36947504b9bea645a921909a894.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/news/img1_2.jpg
// module id = 287
// module chunks = 0